<txtb-modal [title]="action.meta.title">
  <div
    #wrapper
    main
    class="document-wrapper"
    [style.width]="spinnerVisibility ? placeHolderBounds?.width + 'px' : 'auto'"
    [style.height]="spinnerVisibility ? placeHolderBounds?.height + 'px' : 'auto'"
    [class.paginator-hidden]="!pagination"
  >
    <article class="document-image">
      <img
        *ngFor="
          let resourceId of action.meta.resourceIds
            | paginate
              : {
                  itemsPerPage: 1,
                  currentPage: activeElementIndex,
                  totalItems: action.meta.resourceIds.length
                }
        "
        [attr.sub]="imageSrc$(resourceId, activeElementIndex) | async"
        draggable="false"
        class="document-image"
        [src]="imageSrc[activeElementIndex]"
        (load)="onLoad()"
      />
    </article>
    <div class="loader-wrapper" [class.is-visible]="spinnerVisibility">
      <div class="loader"></div>
    </div>
  </div>
  <section class="pagination-wrapper" footer *ngIf="pagination">
    <txtb-documents-paginator
      (pageChange)="changeElement($event)"
      class="paginator"
    ></txtb-documents-paginator>
  </section>
</txtb-modal>
